export default "__VITE_ASSET__BO8vc55c__"